import { useState, useEffect, useRef } from "react";

import "./FAQ.css";

import SectionHeader from "../_components/section-header/SectionHeader";
import SmallCaption from "../_components/small-caption/SmallCaption";
import Question from "./question/Question";

import questionsAnswers from "./questionsAnswers";
import createAnimation from "../_utils/createAnimation";

const FAQ = () => {
  const [currQuestion, setCurrQuestion] = useState(null);
  const ref = useRef(null);

  useEffect(() => createAnimation(ref), []);

  const faq = questionsAnswers.map(({ question, answer }, i) => {
    const handleShowing = () =>
      currQuestion === i ? setCurrQuestion(null) : setCurrQuestion(i);
    return (
      <Question
        id={i}
        key={i}
        question={question}
        answer={answer}
        isShowing={i === currQuestion}
        handleShowing={handleShowing}
      />
    );
  });

  return (
    <section className="FAQ" ref={ref}>
      <SmallCaption text="FAQ" />
      <SectionHeader text="Frequently Asked Questions" />
      {faq}
    </section>
  );
};

export default FAQ;
